import api from '../api';
import { ENDPOINTS } from '../../constants/apiEndpoints';

export const fetchMasterNoticeUrl = () => {
  return api.get(ENDPOINTS.fetch_master_notice.url);
};

export const createUpdateMasterNoticeUrl = (payload) => {
  return api.post(ENDPOINTS.create_update_master_notice.url, payload);
};
